/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
type TradePromo_viewer$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type PdpSharedPromoCode_viewer$ref: FragmentReference;
export type PdpSharedPromoCode_viewer = {|
  +$fragmentRefs: TradePromo_viewer$ref,
  +$refType: PdpSharedPromoCode_viewer$ref,
|};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "PdpSharedPromoCode_viewer",
  "type": "Viewer",
  "metadata": null,
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "isTrade",
      "type": "Boolean"
    }
  ],
  "selections": [
    {
      "kind": "Condition",
      "passingValue": true,
      "condition": "isTrade",
      "selections": [
        {
          "kind": "FragmentSpread",
          "name": "TradePromo_viewer",
          "args": null
        }
      ]
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = 'f63fa07c219aacd664a081e71e472814';
module.exports = node;
